import React, { Component } from "react";
import { connect } from "react-redux";
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { cekCookies } from "../../../../actions";
import { CONFIG, CONFIG_UTIL } from "../../../../config";
import accountManagement from "../../../../apis/accountManagement";
import ReportHwEntity from "../../../../entity/ReportHwEntity";
import __ from "lodash";
import Loader from "../../../Loader";
import LoaderModal from "../../../modal/LoaderModal";
import Alert from "@material-ui/lab/Alert";
import IconButton from "@material-ui/core/IconButton";
import logo_hw from "./images/banner_homework_report.png";

class ReportHwExcel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            isLoading: false,
            dialogShow: false,
            alertShow: false,
            alertMessage: "",
            idAdmin: null,
            idProvinsi: null,
            idDinas: null,
            namaDinas: null,
            dataSubProfil: {},
            detailGuru: {},
            dataReport: [],
        };
    }

    async componentDidMount() {
        document.title = "Report Homework Excell";
        console.clear();
        console.time("Time componentDidMount");
        this.setState({
            isFetching: true,
        });
        await this.props.cekCookies();

        console.groupCollapsed("componentDidMount");
        console.info("CEK ACCOUNT", this.props.account);
        console.info("PARAM 1", this.props.match.params.idProfil);
        console.info("PARAM 2", this.props.match.params.idJadwalProfil);
        console.info("PARAM 3", this.props.match.params.idKp);
        console.info("PARAM 4", this.props.match.params.ta1 + "/" + this.props.match.params.ta2);
        console.groupEnd();

        if (!__.isEmpty(this.props.account)) {
            this.setState({
                idAdmin: this.props.account.idAdmin,
                idProvinsi: this.props.account.idProvinsi,
                idDinas: this.props.account.idDinas,
                namaDinas: this.props.account.namaUser,
            });

            // Fetch Report Homework by Kelasparalel
            const fetchKelas = await accountManagement
                .post(CONFIG.HW_REPORT_BY_KP, {
                    ...ReportHwEntity,
                    idProfil: this.props.match.params.idProfil,
                    idKp: this.props.match.params.idKp,
                    idJadwalProfil: this.props.match.params.idJadwalProfil,
                    kodeTa: this.props.match.params.ta1 + "/" + this.props.match.params.ta2,
                })
                .catch(function (error) {
                    console.error("ERROR HW_REPORT_BY_KP", error);
                });
            console.info("Response fetchKelas", fetchKelas);

            // Set State Report Homework by Kelasparalel
            if (fetchKelas.request.readyState === 4 && fetchKelas.status === 200) {
                console.log("CEK KELAS", fetchKelas);
                if (fetchKelas.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        dataReport: fetchKelas.data.data.dataReport,
                        dataSubProfil: fetchKelas.data.data.dataSubProfil,
                        detailGuru: fetchKelas.data.data.detailGuru,
                    });
                }
            }
        }

        this.setState({
            isFetching: false,
        });
        console.timeEnd("Time componentDidMount");
    }

    renderJudulTabel() {
        return (
            <thead>
                <tr>
                    <th scope="col" style={{ textAlign: "center" }}>
                        No
                    </th>
                    <th scope="col" style={{ textAlign: "left" }}>
                        Nama Siswa
                    </th>
                    <th scope="col" style={{ textAlign: "center" }}>
                        Jumlah Soal
                    </th>
                    <th scope="col" style={{ textAlign: "center" }}>
                        Jumlah Benar
                    </th>
                    <th scope="col" style={{ textAlign: "center" }}>
                        Jumlah Salah
                    </th>
                    <th scope="col" style={{ textAlign: "center" }}>
                        Nilai
                    </th>
                    <th scope="col" style={{ textAlign: "center" }}>
                        Ketuntasan
                    </th>
                </tr>
            </thead>
        );
    }

    renderIsiTable() {
        return (
            <tbody>
                {this.state.dataReport.map((itemReport, indexReport) => {
                    return (
                        <tr key={indexReport} data-attr-id-siswa={itemReport.idSiswa}>
                            <td style={{ textAlign: "center" }}>{indexReport + 1}</td>
                            <td>{itemReport.namaSiswa}</td>
                            <td style={{ textAlign: "center" }}>{itemReport.jumlahSoal}</td>
                            <td style={{ textAlign: "center" }}>{parseInt(itemReport.benar)}</td>
                            <td style={{ textAlign: "center" }}>{parseInt(itemReport.salah)}</td>
                            <td style={{ textAlign: "center" }}>{parseInt(itemReport.skor)}</td>
                            {parseFloat(itemReport.skor, 0) >= parseFloat(this.state.dataSubProfil.kkm) ? <td style={{ color: "#0d9400", textAlign: "center" }}>Tuntas</td> : <td style={{ color: "#ff0000", textAlign: "center" }}>Belum Tuntas</td>}
                        </tr>
                    );
                })}
            </tbody>
        );
    }

    render() {
        console.groupCollapsed("CEK State/Props ReportHwExcel");
        console.info("State", this.state);
        console.info("Props", this.props);
        console.groupEnd();

        const filename = "Report_homework_" + this.state.detailGuru.NAMA_GURU + "_" + this.state.dataSubProfil.namaSubProfil;

        return (
            <div className="container">
                <LoaderModal isFetching={this.state.isFetching} />

                <div style={{ paddingBottom: "50px" }}>
                    <div className="text-right">
                        {/* <ReactHTMLTableToExcel
                            className="btn btn-info"
                            table="emp"
                            filename={ filename }
                            sheet="Sheet"
                            buttonText="Export excel" /> */}
                    </div>
                    <br />

                    {/*
                    <div className="row">
                        <div className="col-md-12">
                            <img src={logo_hw} width="100%"></img>
                        </div>
                    </div>
                    
                    <br/>
                    <div className="row">
                        <div className="col-2">Nama Guru</div>
                        <div className="col-10">: { this.state.detailGuru.NAMA_GURU }</div>
                    </div>

                    <div className="row">
                        <div className="col-2">Mata Pelajaran</div>
                        <div className="col-10">: { this.state.dataSubProfil.namaSubProfil }</div>
                    </div>
                    <br/>
                    */}

                    <div className="row">
                        <div className="col-12">
                            <table id="emp" className="table table-custom">
                                {this.renderJudulTabel()}

                                {this.renderIsiTable()}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    loading = () => {
        if (this.state.isLoading) {
            return <Loader />;
        }
    };

    showAlert = () => {
        if (this.state.alertShow) {
            return (
                <Alert
                    severity="info"
                    action={
                        <IconButton aria-label="close" color="inherit" size="small" onClick={() => this.setState({ alertShow: false })}>
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </IconButton>
                    }
                >
                    <strong>{this.state.alertMessage}</strong>
                </Alert>
            );
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(ReportHwExcel);
